import React from 'react'
import Link, { navigateTo } from 'gatsby-link'
import styled from 'styled-components'
import Picture from './Picture'
import queryString from 'query-string'
import coverImages from './coverImages.js'

const Portfolio = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`

const PortfolioCategory = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	margin: 8vh 0vw 5vh 0vw;
	a {
		text-decoration: none;
		color: black;
	}

	span {
		cursor: pointer;
	}

	@media (max-width: 480px){
		flex-wrap: wrap;
		margin: 5vh 0 3.5vh 0;
		max-width: 14em;
	}
`

const PortfolioCategories = styled.p`
	font-family: Roboto;
	font-size: 22px;
	font-weight: 300;
	margin: 0 1.5vw 0 1.5vw;

	&:hover{
		color: darkgrey;
	}

	@media (max-width: 480px){
		font-size: 17px;
		margin: 0 2vw 1.5vh 2vw;
	}
`

const Projects = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;
	justify-content: center;
	margin:  0 5vw 5vh 5vw;
	max-width: 1500px;
    width: 90%;
`

const ProjectItem = styled(Link)`
	text-decoration: none;
	flex-basis: 420px;
    margin: 10px;
    margin-bottom: ${props => props.isMobile ? '0px' : '10px'}
	
	@media (max-width: 980px){
		flex-basis: 42%;
	}
`

const PortfolioImage = styled.div`
	display: flex;
	flex-wrap: wrap;
	position: relative;
	flex-basis: 33%;

	&:hover > div{
		opacity: 0.8;
		cursor: pointer;
	}

	&:hover > p {
		opacity: 1;
	}

	img {
		margin: 0;
	}
`

const Overlay = styled.div`
	background-color: ${props => props.overlay};
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	opacity: 0;

	@media (max-width: 480px){
		height: 86.5%;
	}

`
	// @media (max-width: 480px){
	// 	display: none;
	// }

const OverlayText = styled.p`
	font-size: 30px;
	font-family: Roboto;
	font-weight: 300;
	text-align: center;
	color: ${props => props.isMobile ? 'black' : 'white'};;
	width: 100%;
	position: ${props => props.isMobile ? 'static' : 'absolute'};
	opacity: 0;
	cursor: pointer;
	top: ${props => props.isMobile ? 'auto' : '50%'};
  	left: ${props => props.isMobile ? 'auto' : '50%'};
  	transform: ${props => props.isMobile ? 'initial' : 'translate(-50%, -50%)'};

  	${props => props.isMobile ? `
	font-size: 1em;
	opacity: 1;
	top: initial;
	bottom: -36px;
	margin: 0;
` : ''}

	@media (max-width: 480px){
		font-size: 16px;
	}
`
// <span onClick={ () => navigateTo('/?category=konzept')}><PortfolioCategories>Konzept</PortfolioCategories></span>
// <span onClick={ () => navigateTo('/?category=report')}><PortfolioCategories>Reportage</PortfolioCategories></span>

const isCategory = ({image, category}) => image.tag === category

export default class PortfolioPage extends React.Component {
	constructor(props) {
	    super(props);
	    this.state = {isMobile: false};
 	 }

 	 componentDidMount() {
 	 	this.setState({
 	 		isMobile: ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )
 	 	})
 	 }

	render() {
		const { isMobile } = this.state
		return(
			<Portfolio id="portfolio">
				<PortfolioCategory>
					<Link to = '/?category=konzept'><PortfolioCategories>Konzept</PortfolioCategories></Link>
					<Link to = '/?category=report'><PortfolioCategories>Reportage</PortfolioCategories></Link>
					<Link to = '/portrait'><PortfolioCategories>Portrait</PortfolioCategories></Link>
					<Link to = '/collage'><PortfolioCategories>Digital Collage</PortfolioCategories></Link>
				</PortfolioCategory>
				<Projects>
					{coverImages
						.filter((image) => {
							const category = queryString.parse(this.props.location.search).category
							return category ? isCategory({image, category}) : true
						})
						.map(coverImage => (
							<ProjectItem key={coverImage.image} to = {`./projects/${coverImage.link}`} isMobile={isMobile}>
								<PortfolioImage>
									<Picture imagecode={coverImage.image} size="cover"/>
									<Overlay overlay={coverImage.color}></Overlay>
									<OverlayText isMobile={isMobile}>{coverImage.text}</OverlayText>
								</PortfolioImage>
							</ProjectItem>
					))}
				</Projects>
			</Portfolio>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/PortfolioPage.js